<script setup>
import { ref, onMounted } from 'vue';
import { useCurrentMenuStore } from "../../stores/current-menu";

const props = defineProps({
    currentMenuItem: { required: true },
    measure: { required: true },
    item: { required: true },
});

const currentMenuStore = useCurrentMenuStore();

const editing = ref(false);

onMounted(() => {
    document.addEventListener("mousedown", function (e) {
        if (editing.value && e.target.id !== `${props.item.name}-${props.item.id}`) {
            editing.value = false;

            resetPrice();
        }
    });
});

function resetPrice() {
    if (!props.item.price && props.item.price !== 0) {

        let prices = currentMenuStore.menuItems.filter((item) => {
            if (props.currentMenuItem == item.product_id && props.measure == item.measure) {
                return true;
            }
        })[0].prices;

        prices = JSON.parse(prices);

        let setPrice = 0;
        if (prices != null) {
            setPrice = prices[props.item.id];
        }


        props.item.price = setPrice;
        props.item.overridden = false;
    } else {

        let prices = currentMenuStore.menuItems.filter((item) => {
            if (props.currentMenuItem == item.product_id && props.measure == item.measure) {
                return true;
            }
        })[0].prices;

        prices = JSON.parse(prices);
        let originalPrice = 0;

        if (prices != null) {
            originalPrice = prices[props.item.id];
        }

        if (originalPrice != props.item.price) {
            props.item.overridden = true;
        } else {
            props.item.overridden = false;
        }

    }
}

</script>

<template>
    <input type="checkbox" v-model="item.active" @change="getPrices" />
    <p>{{ item.name }}</p>
    <p class="price can-edit" :class="{ 'overridden': item.overridden }" @click="editing = !editing" v-if="!editing">£{{
            parseFloat(item.price).toFixed(2)
    }}</p>
    <input type="number" :id="`${item.name}-${item.id}`" v-else v-model="item.price">
</template>

<style lang="scss" scoped>
.price {
    margin-left: auto;

    &.overridden {
        font-weight: bold;
        color: red;
    }
}

input[type="number"] {
    width: 100px;
    appearance: none;
    margin-left: auto;
    margin-bottom: 0;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
    }
}

@media screen and (max-width: 900px) {
    input[type=checkbox] {
        margin-right: 5px;
    }
}
</style>